import classNames from "classnames";
import { isNotEmpty, isPresent } from "neetocist";
import { Typography } from "neetoui";

import RenameMenu from "./RenameMenu";

const ViewName = ({
  disabled,
  textProps,
  formatText,
  dropdownItems,
  hideMenu,
  handleRenameClick,
  onArchiveStatusToggle,
  onDisableStatusToggle,
  onClone,
  onDelete,
  name,
  isArchived,
  isDisabled,
  dropdownButtonProps,
  dropdownProps,
}) => {
  const isDefaultMenuCallbacksPresent =
    isPresent(onArchiveStatusToggle) ||
    isPresent(onDisableStatusToggle) ||
    isPresent(onDelete) ||
    isPresent(onClone);

  const isMenuVisible =
    !hideMenu &&
    (isNotEmpty(dropdownItems) || !disabled || isDefaultMenuCallbacksPresent);

  return (
    <>
      <Typography
        component="p"
        data-testid="form-title"
        style="body2"
        className={classNames(
          "neeto-molecules-rename__text neeto-molecules-rename__display-text w-full truncate",
          {
            "cursor-pointer": !disabled,
            "pointer-events-none cursor-text": disabled,
          }
        )}
        onClick={handleRenameClick}
        {...textProps}
      >
        {typeof formatText === "function" ? formatText(name) : name}
      </Typography>
      {isMenuVisible && (
        <RenameMenu
          {...{
            disabled,
            dropdownButtonProps,
            dropdownItems,
            dropdownProps,
            handleRenameClick,
            isArchived,
            isDisabled,
            onArchiveStatusToggle,
            onClone,
            onDelete,
            onDisableStatusToggle,
          }}
        />
      )}
    </>
  );
};

export default ViewName;
